import { memo, useContext } from "react";
import "./SmartDPListingListLoader.scss";
import appGlobalsContext from "app/AppGlobalsContext";
import { RESOLUTION } from "app/pages/.shared/responsive/responsiveReducer";

const SmartDPListingListLoader = () => {
	const { resolution } = useContext(appGlobalsContext);
	const isMobile = resolution === RESOLUTION.SMALL || resolution === RESOLUTION.MEDIUM;

	const { publicPath = "" } = useContext(appGlobalsContext);
	return (
		<div className="sdp-listing-list-loader">
			<div className="sdp-listing-list-loader__container">
				{[...Array(9)].map((x, i) => {
					const testIdClassName = `sdp-listing-list-loader__skeleton--card-${i}`;
					return (
						<img
							alt="skeleton"
							className="sdp-listing-list-loader__skeleton"
							data-testid={testIdClassName}
							key={i}
							src={
								isMobile
									? `${publicPath}/icons/card_listing_skeleton_MOB.svg`
									: `${publicPath}/icons/card-listing_skeleton_DESK.svg`
							}
						/>
					);
				})}
			</div>
		</div>
	);
};

export default memo(SmartDPListingListLoader);
